(function () {
  'use strict';

  // Skip in Shopify editor to avoid visual issues
  if (typeof Shopify !== 'undefined' && Shopify.designMode) return;

  var STAGGER = 150;        // ms delay between staggered items
  var DURATION = 1000;      // ms transition duration
  var EASING = 'cubic-bezier(0.22, 1, 0.36, 1)';
  var ROOT_MARGIN = '0px 0px -180px 0px';
  var CARD_BATCH_WINDOW = 80; // ms window to collect cards entering at the same scroll position

  // Inject CSS — only opacity + transform for GPU-accelerated animation
  var style = document.createElement('style');
  style.textContent =
    '[data-anim]{' +
      'opacity:0;' +
      'transform:translateY(55px);' +
      'transition:' +
        'opacity ' + DURATION + 'ms ' + EASING + ' var(--anim-delay,0ms),' +
        'transform ' + DURATION + 'ms ' + EASING + ' var(--anim-delay,0ms);' +
      'will-change:opacity,transform;' +
    '}' +
    '[data-anim].anim-in{opacity:1;transform:none;}' +
    '[data-anim].anim-done{will-change:auto;}';
  document.head.appendChild(style);

  function inViewport(el) {
    var r = el.getBoundingClientRect();
    return r.top < window.innerHeight && r.bottom > 0;
  }

  // Hide an element (no index — delay assigned later at flush time)
  function hideEl(el) {
    el.setAttribute('data-anim', '');
  }

  // Reveal a batch of elements with stagger delays assigned in order
  function revealEls(elements) {
    if (!elements.length) return;
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        elements.forEach(function (el, i) {
          if (i === 0) {
            el.style.removeProperty('--anim-delay');
          } else {
            el.style.setProperty('--anim-delay', (i * STAGGER) + 'ms');
          }
          el.classList.add('anim-in');
        });
        var totalMs = DURATION + (elements.length - 1) * STAGGER + 50;
        setTimeout(function () {
          elements.forEach(function (el) { el.classList.add('anim-done'); });
        }, totalMs);
      });
    });
  }

  // Observer: group-block-content containers
  var groupObserver = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      groupObserver.unobserve(entry.target);
      var hidden = Array.from(entry.target.querySelectorAll(':scope > [data-anim]'));
      revealEls(hidden);
    });
  }, { rootMargin: ROOT_MARGIN, threshold: 0.05 });

  // Observer: individual product-card elements
  // Cards entering the viewport within CARD_BATCH_WINDOW ms are grouped and staggered together
  var cardBatch = [];
  var cardBatchTimer = null;

  function flushCardBatch() {
    var batch = cardBatch.slice();
    cardBatch = [];
    cardBatchTimer = null;
    revealEls(batch);
  }

  var cardObserver = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      cardObserver.unobserve(entry.target);
      cardBatch.push(entry.target);
      if (!cardBatchTimer) {
        cardBatchTimer = setTimeout(flushCardBatch, CARD_BATCH_WINDOW);
      }
    });
  }, { rootMargin: ROOT_MARGIN, threshold: 0.05 });

  function init() {
    // Process outer-to-inner so data-anim is set on ancestors first.
    // General rule: if closest('[data-anim]') exists, the element is already
    // inside an animated unit and must be skipped.

    // 1. product-card / .featured-blog-posts-card — outermost animated units, processed first
    document.querySelectorAll('product-card, .featured-blog-posts-card').forEach(function (card) {
      if (card.closest('[data-anim]')) return;
      hideEl(card);
      cardObserver.observe(card);
    });

    // 2. .layout-panel-flex--row — skip if inside an already-animated element
    document.querySelectorAll('.layout-panel-flex--row').forEach(function (row) {
      if (row.closest('slideshow-slide')) return;
      if (row.closest('[data-anim]')) return;
      if (inViewport(row)) return;

      var children = Array.from(row.children).filter(function (el) {
        return el.tagName !== 'SCRIPT' && el.tagName !== 'STYLE' && el.tagName !== 'TEMPLATE';
      });
      if (!children.length) return;

      children.forEach(function (el) { hideEl(el); });
      groupObserver.observe(row);
    });

    // 3. .group-block-content — skip if inside an already-animated element
    document.querySelectorAll('.group-block-content').forEach(function (container) {
      if (container.closest('slideshow-slide')) return;
      if (container.closest('[data-anim]')) return;
      if (inViewport(container)) return;
      if (!container.children.length) return;

      var children = Array.from(container.children).filter(function (el) {
        return el.tagName !== 'SCRIPT' && el.tagName !== 'STYLE' && el.tagName !== 'TEMPLATE';
      });
      if (!children.length) return;

      children.forEach(function (el) { hideEl(el); });
      groupObserver.observe(container);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.scrollAnimations = { init: init };
})();
